import type {
  AssignDriverRequest,
  ConfirmRouteRequest,
  AddShippingsToRouteRequest,
  CancelRouteRequest,
  RouteCloneCandidatesRequest,
} from '../models';

export function trimId(value?: string | null): string {
  return value?.trim() ?? '';
}

export function buildAssignDriverRequest(
  params: AssignDriverRequest
): { url: string; method: string; body: { driverId: string }; headers: Record<string, string> } {
  return {
    url: `/${params.routeId}/assign-driver`,
    method: 'PATCH',
    body: { driverId: params.driverId },
    headers: {
      'x-logistic-operator-id': trimId(params.logisticOperatorId),
    },
  };
}

export function buildReassignDriverRequest(
  params: AssignDriverRequest
): { url: string; method: string; body: { driverId: string }; headers: Record<string, string> } {
  return {
    url: `/${params.routeId}/reassign-driver`,
    method: 'PATCH',
    body: { driverId: params.driverId },
    headers: {
      'x-logistic-operator-id': trimId(params.logisticOperatorId),
    },
  };
}

export function buildConfirmRouteRequest(
  params: ConfirmRouteRequest
): { url: string; method: string; headers: Record<string, string> } {
  return {
    url: `/${params.routeId}/confirm`,
    method: 'PATCH',
    headers: {
      'x-logistic-operator-id': trimId(params.logisticOperatorId),
      'x-driver-id': trimId(params.driverId),
    },
  };
}

export function buildAddShippingsToRouteRequest(
  params: AddShippingsToRouteRequest
): {
  url: string;
  method: string;
  body: Omit<AddShippingsToRouteRequest, 'routeId' | 'logisticOperatorId'>;
  headers: Record<string, string>;
} {
  const body: Omit<AddShippingsToRouteRequest, 'routeId' | 'logisticOperatorId'> =
    {
      shippingNumbers: params.shippingNumbers,
      ...(params.type && { type: params.type }),
      ...(params.lat !== undefined && { lat: params.lat }),
      ...(params.long !== undefined && { long: params.long }),
    };
  return {
    url: `/${params.routeId}/add-shippings-without-scan-order`,
    method: 'POST',
    body,
    headers: {
      'x-logistic-operator-id': trimId(params.logisticOperatorId),
    },
  };
}

export function buildCancelRouteRequest(
  params: CancelRouteRequest
): { url: string; method: string; headers: Record<string, string> } {
  return {
    url: `/${params.routeId}/cancel`,
    method: 'PATCH',
    headers: {
      'x-logistic-operator-id': trimId(params.logisticOperatorId),
    },
  };
}

export function buildRouteCloneCandidatesRequest(
  params: RouteCloneCandidatesRequest
): { url: string; method: string; headers: Record<string, string> } {
  return {
    url: `/${params.routeId}/clone-candidates`,
    method: 'GET',
    headers: {
      'x-logistic-operator-id': trimId(params.logisticOperatorId),
    },
  };
}
